// extracted by mini-css-extract-plugin
export var banner = "_cj-0";
export var closeButton = "_cj-2";
export var greenCheckmark = "_cj-3";
export var hereLink = "_cj-4";
export var titleIcon = "_cj-1";